import { trackingApplicationDomain, trackingDomain } from '@unipile/db';
import { Type, type Static } from '@sinclair/typebox';
import { createInsertSchema, createSelectSchema } from 'drizzle-typebox';

export const CustomDomainTypeSchema = Type.Union([Type.Literal('hosted_auth'), Type.Literal('tracking')]);

export const TrackingDomainSchema = createSelectSchema(trackingDomain);
export const InsertTrackingDomainSchema = createInsertSchema(trackingDomain);
export const TrackingApplicationDomainSchema = createSelectSchema(trackingApplicationDomain);
export const InsertTrackingApplicationDomainSchema = createInsertSchema(trackingApplicationDomain);

export type CustomDomainType = Static<typeof CustomDomainTypeSchema>;
export type TrackingDomain = typeof trackingDomain.$inferSelect;
export type InsertTrackingDomain = typeof trackingDomain.$inferInsert;
export type TrackingApplicationDomain = typeof trackingApplicationDomain.$inferSelect;
export type InsertTrackingApplicationDomain = typeof trackingApplicationDomain.$inferInsert;
